/** Sheet Height / Length / Width are assembled box dimensions in inches (shipping uses collapsed mailers). */

export function formatInches(value) {
  const n = Number(value);
  if (!Number.isFinite(n) || n <= 0) return null;
  if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
  return String(Math.round(n * 10) / 10);
}

export function buildBoxSizeLabel({ height, length, width }) {
  const l = formatInches(length);
  const w = formatInches(width);
  const h = formatInches(height);
  if (!l || !w || !h) return "Gift Box";
  return `${l} × ${w} × ${h} in`;
}

export function inchesToCm(inches) {
  const n = Number(inches);
  if (!Number.isFinite(n) || n <= 0) return NaN;
  return Math.round(n * 2.54 * 10) / 10;
}
